import React, { memo } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import { PushNextActionDatesPopup } from '../../components/Popup/PushNextActionDatesPopup';
import { showError } from '../../utils/MessagePopup';
import { usePopupContext } from '../../contexts/PopupContext';

const PushNextActionDatesPopupContainer = ({ popup }) => {
  const { closePopup, openPopup, updatePopupFormData, startPopupLoading, endPopupLoading } = usePopupContext();

  const handleChange = event => {
    if (event.target) {
      const { name, type, checked, value } = event.target;

      if (type.toUpperCase() === 'CHECKBOX' && checked) {
        updatePopupFormData({
          forward: name === 'forward',
          backward: name === 'backward',
          following: name === 'following',
        });
      } else {
        updatePopupFormData({
          [name]: type.toUpperCase() === 'CHECKBOX' ? checked : value,
        });
      }
    }
  };

  const handleDateChange = date => {
    updatePopupFormData({
      followingDate: date,
    });
  };

  const handleSuccessResponse = skipNA => {
    if (skipNA) {
      const message = `${skipNA} companies were skipped because they had no next action`;

      showError(openPopup, List([message]));
    }
  };

  const handleUpdate = () => {
    const onUpdate = popup.getIn(['props', 'onUpdate'], () => {});
    const refreshGrid = popup.getIn(['props', 'refreshGrid'], () => {});

    onUpdate(popup.get('formData'), {
      beforeStart: startPopupLoading,
      afterSuccess: ({ response }) => {
        endPopupLoading();
        handleSuccessResponse(response.numberOfSkipped);
        refreshGrid();
      },
      skipGlobalErrorHandler: true,
      afterError: ({ responseBody }) => {
        endPopupLoading(responseBody);
      },
    });
  };

  return (
    <PushNextActionDatesPopup
      formData={popup.get('formData')}
      isPopupFetching={popup.get('isPopupFetching')}
      isPopupFetchingError={popup.get('isPopupFetchingError')}
      onChange={handleChange}
      onClose={closePopup}
      onDateChange={handleDateChange}
      onUpdate={handleUpdate}
    />
  );
};

const PushNextActionDatesPopupContainerMemo = memo(PushNextActionDatesPopupContainer);

export { PushNextActionDatesPopupContainerMemo as PushNextActionDatesPopupContainer };
export default connect((state, props) => ({
  ...props,
}))(PushNextActionDatesPopupContainerMemo);
